import React from 'react';
import { SearchUsersForm } from 'components';

export const SearchUsersPage = props => {
    return <SearchUsersForm {...props} />;
};
